import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";

import styles from "./MembersList.module.css";
import PropTypes from "prop-types";
import MembersItem from "../MembersItem";

/**
 *
 * Scrollable list of admins with a header.
 */

export function MembersList({ members, empty }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.item}>IBO Name</div>
        <div>IBO #</div>

        {!empty && (
          <>
            <div>Plugin ID</div>
            <div>As Admin</div>
            <div>Plugin Type</div>
          </>
        )}
      </div>

      <div className={styles.dragger} {...events} ref={ref}>
        {members.map((item, index) => (
          <div
            className={
              index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
            }
            key={index}
          >
            <MembersItem
              memberInfo={item}
              empty={empty}
              onClick={() => alert("Link to Users")}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

MembersList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
  empty: PropTypes.bool,
};
